(function() {
    // -----------------------
    // Config (production-ready defaults)
    // -----------------------
    const COOLDOWN_MINUTES = 60; // 1440 = 24 hours (change to required minutes)
    const FORCE_REAPPLY_FOR_TESTING = false; // MUST be false in production

    // -----------------------
    // Helpers: cookie read (only used for cart identity) and localStorage helpers
    // -----------------------
    function readCookieRaw(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
      }
      return null;
    }

    function lsGet(key) {
      try {
        return localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }
    function lsSet(key, value) {
      try {
        localStorage.setItem(key, String(value));
      } catch (e) {}
      // same-tab notification; other tabs get native storage event
      try { window.dispatchEvent(new CustomEvent('promoStorageChanged', { detail: { key:key, value:value } })); } catch(e){}
    }
    function lsDelete(key) {
      try { localStorage.removeItem(key); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent('promoStorageChanged', { detail: { key:key } })); } catch(e){}
    }

    // -----------------------
    // Network helpers (idempotent remove)
    // -----------------------
    function removeCartAttribute(key) {
      try {
        var state = lsGet(key + '_state');
        var expiredUntil = parseInt(lsGet(key + '_expired_until') || '0', 10);
        var now = Math.floor(Date.now() / 1000);
        if (state === 'expired' && !isNaN(expiredUntil) && expiredUntil > now) {
          // already expired + cooldown active => no-op
          return Promise.resolve({ noOp: true });
        }
      } catch(e){}

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [key]: '' } })
      })
      .then(resp => resp.json())
      .then(data => {
        try {
          // read cart token from cookie (Shopify source-of-truth)
          var cartToken = readCookieRaw('cart');
          var nowEpoch = Math.floor(Date.now() / 1000);
          if (cartToken) {
            var expiresAtEpoch = nowEpoch + (COOLDOWN_MINUTES * 60);
            lsSet(key + '_expired_for_cart', cartToken);
            lsSet(key + '_expired_until', expiresAtEpoch);
            lsSet(key + '_state', 'expired');
          }
        } catch(e){}
        lsDelete(key + '_createdAt');
        return data;
      })
      .catch(err => { console.error('removeCartAttribute error', err); throw err; });
    }

    function addCartAttribute(key, value) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [key]: value } })
      })
      .then(resp => resp.json())
      .then(data => {
        try { window.dispatchEvent(new CustomEvent('promoApplied', { detail: { id: key, code: value } })); } catch(e){}
        return data;
      })
      .catch(err => { console.error('addCartAttribute error', err); throw err; });
    }

    function fetchCartWithRetry(attempts = 3, delayMs = 300) {
      return new Promise((resolve, reject) => {
        function attempt(remaining) {
          fetch('/cart.js', { cache: 'no-store' })
            .then(resp => resp.json())
            .then(data => {
              const cartHasItems = (typeof data.item_count !== 'undefined') ? data.item_count > 0 : (data.items && data.items.length > 0);
              if (cartHasItems || remaining <= 1) resolve(data);
              else setTimeout(() => attempt(remaining - 1), delayMs);
            })
            .catch(err => {
              if (remaining <= 1) reject(err);
              else setTimeout(() => attempt(remaining - 1), delayMs);
            });
        }
        attempt(attempts);
      });
    }

    // -----------------------
    // Main logic
    // -----------------------
    const jdta = window.STOREFRONT_CAMPAIGNS;
    if (!Array.isArray(jdta) || jdta.length === 0) {
      // no campaigns — nothing to do
      return;
    }

    fetchCartWithRetry(3, 300)
      .then(cartData => {
        const cartHasItems = (typeof cartData.item_count !== 'undefined') ? cartData.item_count > 0 : (cartData.items && cartData.items.length > 0);
        // read cart token directly from cookie (Shopify)
        var cartCookie = readCookieRaw('cart');
        var currentEpoch = Math.floor(Date.now() / 1000);

        for (var i = 0; i < jdta.length; i++) {
          (function(promo) {
            var prevCart = lsGet(promo.id + '_prev_cart');
            var createdAt = lsGet(promo.id + '_createdAt');
            var state = lsGet(promo.id + '_state');
            var expiredUntilRaw = lsGet(promo.id + '_expired_until');
            var expiredUntil = expiredUntilRaw ? parseInt(expiredUntilRaw,10) : NaN;
            var expiredForThisCart = (!isNaN(expiredUntil) && expiredUntil > currentEpoch) && (lsGet(promo.id + '_expired_for_cart') === cartCookie);

            // Force toggle is off in prod; keep code path but never active
            if (FORCE_REAPPLY_FOR_TESTING && state === 'expired') {
              lsDelete(promo.id + '_state');
              lsDelete(promo.id + '_expired_for_cart');
              lsDelete(promo.id + '_expired_until');
              lsDelete(promo.id + '_prev_cart');
              state = null; prevCart = null; createdAt = null;
            }

            if (state === 'expired' && expiredForThisCart) {
              return; // still in cooldown for this cart
            }

            if ((expiredUntilRaw && expiredUntil <= currentEpoch) || (state === 'expired' && !expiredUntilRaw)) {
              // cooldown passed -> clear expired markers and prev_cart so promo can be re-applied
              lsDelete(promo.id + '_state');
              lsDelete(promo.id + '_expired_for_cart');
              lsDelete(promo.id + '_expired_until');
              lsDelete(promo.id + '_prev_cart');
              state = null; prevCart = null; createdAt = null;
            }

            if (prevCart) {
              if (prevCart === cartCookie) {
                if (createdAt) {
                  var createdAtEpoch = parseInt(createdAt, 10);
                  if (!isNaN(createdAtEpoch) && createdAtEpoch < currentEpoch) {
                    removeCartAttribute(promo.id).catch(()=>{});
                  } else {
                    if (state !== 'applied') lsSet(promo.id + '_state', 'applied');
                  }
                } else {
                  // do nothing (we have prevCart but no createdAt)
                }
              } else {
                if (cartHasItems) {
                  addCartAttribute(promo.id, promo.code)
                    .then(() => {
                      var expiresAt = currentEpoch + (promo.duration || 0);
                      lsSet(promo.id + '_createdAt', expiresAt);
                      lsSet(promo.id + '_prev_cart', cartCookie);
                      lsSet(promo.id + '_state', 'applied');
                    })
                    .catch(()=>{});
                }
              }
            } else {
              if (cartHasItems) {
                addCartAttribute(promo.id, promo.code)
                  .then(() => {
                    var expiresAt = currentEpoch + (promo.duration || 0);
                    lsSet(promo.id + '_createdAt', expiresAt);
                    lsSet(promo.id + '_prev_cart', cartCookie);
                    lsSet(promo.id + '_state', 'applied');
                  })
                  .catch(()=>{});
              }
            }
          })(jdta[i]);
        }
      })
      .catch(err => {
        console.error('Could not fetch /cart.js — skipping promo application', err);
      });

    // -----------------------
    // Tab sync (cross-tab + same-tab)
    // -----------------------

    // Other tabs: native 'storage' event will fire when localStorage changes
    window.addEventListener('storage', function(e){
      try {
        if (!e || !e.key) return;
        if (e.key.indexOf('_createdAt') !== -1 || e.key.indexOf('_state') !== -1) {
          var id = e.key.split('_')[0];
          try { window.dispatchEvent(new CustomEvent('promoStorageSynced', { detail: { id: id, key: e.key, value: e.newValue } })); } catch(e){}
        }
      } catch (err) {}
    });

    // Same tab: our lsSet/lsDelete dispatches promoStorageChanged
    window.addEventListener('promoStorageChanged', function(e){
      try {
        if (!e || !e.detail || !e.detail.key) return;
        var k = e.detail.key;
        if (k.indexOf('_createdAt') !== -1 || k.indexOf('_state') !== -1) {
          var id = k.split('_')[0];
          try { window.dispatchEvent(new CustomEvent('promoStorageSynced', { detail: { id: id, key: k, value: e.detail.value } })); } catch(e){}
        }
      } catch(err){}
    });

  })();